const { fetchWithRetry } = require('./utils'); // Utility function to parse cookies  

// Function to fetch the selected competition  
export const fetchSelectedCompetition = async () => {
    try {
        const response = await fetchWithRetry('/api/selected-competition', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch selected competition');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching selected competition:', error);
        throw error;
    }
};

// Function to fetch the image path  
export const fetchImagePath = async () => {
    try {
        const response = await fetchWithRetry('/api/selected-competition/imagepath', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch image path');
        }

        return await response.json();
    } catch (error) {
        console.error('Error in fetchImagePath:', error);
        throw error;
    }
};  